// extracted by mini-css-extract-plugin
var _1 = "20px";
var _2 = "TopicTreeCardDropSeparatorStack-module__container--ACmcB";
export { _1 as "cardLevelIndent", _2 as "container" }
